<template lang="pug">
.container
  .content-conversas.full-width
    .conversas-main
      .busca-conversas
        search-conversas(
          @search="search"
          @limpar="handleLimpar"
          :botaoLimpar="true"
        )
  .content-conversas.full-width
    .conversas-main
      .listagem-conversas
        listagem-conversas(
          :conversas="conversas"
        )
      app-paginacao(
        :total="totalConversas",
        :pagina="paginaFiltro.pagina + 1",
        :tamanhoPagina="paginaFiltro.tamanhoPagina",
        @changePage="changePage"
      )
</template>

<script>
import { mapActions } from 'vuex'

import MainHeader from '@/components/MainHeader'
import ListagemConversas from '@/screens/ouvidoria/components/ListagemConversas.vue'
import SearchConversas from '@/screens/central/comunicacao/SearchConversas.vue'
import AppPaginacao from '@/components/AppPaginacao'

export default {

  components: {
    MainHeader,
    ListagemConversas,
    SearchConversas,
    AppPaginacao
  },

  data () {
    return {
      conversas: [],
      loading: false,
      paginaFiltro: {
        pagina: 0,
        tamanhoPagina: 15
      },
      totalConversas: 0,
      filtroPesquisa: {}
    }
  },

  methods: {
    ...mapActions({
      getConversasByFilter: 'conversas/getConversasByFilter'
    }),

    async findConversas (filtro) {
      this.loading = true
      const result = await this.getConversasByFilter(filtro)
      this.conversas = result.conversas
      this.loading = false
      this.totalConversas = result.total
    },

    search (filtroAtualizado) {
      this.filtroPesquisa = filtroAtualizado.assunto !== ''
        ? { ...this.filtroPesquisa, assunto: filtroAtualizado.assunto } : this.filtroPesquisa = ''
      this.filtroPesquisa = filtroAtualizado.status !== ''
        ? { ...this.filtroPesquisa, status: filtroAtualizado.status } : this.filtroPesquisa
      this.filtroPesquisa = filtroAtualizado.firstInicioConversa !== ''
        ? { ...this.filtroPesquisa, firstInicioConversa: filtroAtualizado.firstInicioConversa } : this.filtroPesquisa
      this.filtroPesquisa = filtroAtualizado.lastInicioConversa !== ''
        ? { ...this.filtroPesquisa, lastInicioConversa: filtroAtualizado.lastInicioConversa } : this.filtroPesquisa
      this.filtroPesquisa = filtroAtualizado.firstUltimaResposta !== ''
        ? { ...this.filtroPesquisa, firstUltimaResposta: filtroAtualizado.firstUltimaResposta } : this.filtroPesquisa
      this.filtroPesquisa = filtroAtualizado.lastUltimaResposta !== ''
        ? { ...this.filtroPesquisa, lastUltimaResposta: filtroAtualizado.lastUltimaResposta } : this.filtroPesquisa
      this.filtroPesquisa = { ...this.filtroPesquisa, ...this.paginaFiltro }

      this.findConversas(this.filtroPesquisa)
    },

    handleLimpar (filtroAtualizado) {
      filtroAtualizado.assunto = ''
      filtroAtualizado.status = ''
      filtroAtualizado.firstInicioConversa = ''
      filtroAtualizado.lastInicioConversa = ''
      filtroAtualizado.firstUltimaResposta = ''
      filtroAtualizado.lastUltimaResposta = ''
      this.search(filtroAtualizado)
    },

    changePage (newPage) {
      this.paginaFiltro.pagina = newPage - 1
      this.search(this.filtroPesquisa)
    }
  }
}
</script>

<style lang="scss" scoped>

  .container {
    display: flex;
    flex-direction: column;
  }

  .full-width {
    width: 100%;
  }

  /deep/ .cell {
    color: #424242;
  }
</style>



// WEBPACK FOOTER //
// src/screens/ouvidoria/Home.vue